<template>
  <md-dialog
    :md-active.sync="isOpen"
    :md-backdrop="true"
    :md-fullscreen="true"
    :md-close-on-esc="true"
    v-on:md-closed="onClose"
  >
    <md-dialog-title>
      <div class="">
        <div>
         Add New Customer
        </div>
      </div>
    </md-dialog-title>

     <md-dialog-content>
      <!-- Fields -->
      <div>
        <md-field>
          <label>Customer Phone Number</label>
          <md-input
            v-model="form.phone"
            placeholder="Enter Customer Phone Number"
            id="phone"
          ></md-input>
        </md-field>
        <md-field>
          <label for="name">Customer Name</label>
          <md-input
            v-model="form.name"
            placeholder="Enter Customer Name"
            id="name"
          ></md-input>
        </md-field>
        <md-field>
          <label for="email"> Customer Email</label>
          <md-input
            v-model="form.email"
            placeholder="Enter Customer Email"
            id="email"
          ></md-input>
        </md-field>
      </div>

      <div>
        <md-button
          class="md-block md-primary"
          @click="createNewUser()"
          >{{isLoading ? 'Creating ... PLEASE WAIT' : 'Create Customer'}}</md-button
        >
      </div>
    </md-dialog-content>

    <md-dialog-actions>
      <md-button @click="onClose()">Close</md-button>
    </md-dialog-actions>
    <md-snackbar
      md-position="center"
      :md-duration="6000"
      :md-active.sync="snackBar.show"
      md-persistent
    >
      <span>{{ snackBar.message }}</span>
    </md-snackbar>
  </md-dialog>

</template>

<script>
import { format } from 'date-fns';
import http from '../../../utils/Http.util';
import InputValidators from '../../../utils/InputValidators.util';

export default {
  name: 'customer-modal',
  data() {
    return {
      isOpen: false,
      isLoading: false,
      form: {
        name: '',
        email: '',
        phone: '',
      },
      snackBar: {
        show: false,
        message: null,
      },
    };
  },
  methods: {
    format,
    onOpen() {
      this.isOpen = true;
    },
    onClose() {
      this.isOpen = false;
    },
    async createNewUser() {
      try {
        const phone = InputValidators.mustBePhoneNumber(this.form.phone);
        if (!this.form.name || !phone) {
          this.snackBar = {
            show: true,
            message: 'Please Provide a Valid Phone Number and Name',
          };
          return;
        }
        if (this.isLoading) {
          this.snackBar = {
            show: true,
            message: 'Operation In Progress',
          };
          return;
        }
        this.$store.commit('busyStatus', true);
        this.isLoading = true;

        await http.authReq('/dashboard/customers/', {
          ...this.form,
        },
        'post');
        this.$store.commit('busyStatus', false);
        this.isLoading = false;
        this.snackBar = {
          show: true,
          message: 'Successfully',
        };
        setTimeout(() => {
          this.onClose();
        }, 3000);
      } catch (err) {
        this.$store.commit('busyStatus', false);
        this.isLoading = false;
        this.snackBar = {
          show: true,
          message: err.message || 'Unable to Add New User',
        };
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.md-table .md-table-row {
  cursor: pointer;
}
.flex {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.table-body {
  overflow-x: auto;
  scroll-behavior: auto;
}

.md-dialog /deep/.md-dialog-container {
  // max-width: 100%;
  min-width: 30%;
}

.body {
  max-width: 100%;
}
</style>
